import { FormFieldOption } from "app/shared/components/form-fields/base-input/base-input.component";
import { IOrganizationUser } from "../../organizations/model/IOrganizationUser";

/**
 * Extract trader IDs (string[]) from a campaign payload.
 * Supports: traders (array of { id, name }), trader_ids, traderIds, or legacy single trader.
 * Used when loading campaign details and when filtering the campaign list.
 */
export function getTraderIdsFromCampaign(campaign: any): string[] {
    if (!campaign) return [];
    const traders = campaign.traders;
    if (traders != null && Array.isArray(traders)) {
        return traders.map((t: any) => (t?.id != null ? String(t.id) : null)).filter(Boolean);
    }
    const arr = campaign.trader_ids ?? campaign.traderIds;
    if (arr != null && Array.isArray(arr)) {
        return arr.map((id: any) => String(id)).filter(Boolean);
    }
    const single = campaign.trader;
    if (single != null && single !== "") return [String(single)];
    return [];
}

/**
 * Map organization users to FormFieldOption[] for trader selectors.
 * Single place for display label: name || email || username || id.
 */
export function mapOrganizationUsersToTraderOptions(users: IOrganizationUser[]): FormFieldOption[] {
    return users.map((user) => ({
        key: String(user.id ?? ""),
        value: user.name?.trim() || user.email || user.username || user.id,
    }));
}
